import { render, staticRenderFns } from "./DeliveryFeeComparison.vue?vue&type=template&id=cc00f07e&scoped=true&"
import script from "./DeliveryFeeComparison.vue?vue&type=script&lang=js&"
export * from "./DeliveryFeeComparison.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFeeComparison.vue?vue&type=style&index=0&id=cc00f07e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc00f07e",
  null
  
)

export default component.exports